export default {
    message: {
        title: 'Celler de Vila-seca',
        preferVisitRead: '',
        preferVisitListten: '',
        preferVisitComplete: 'Completa',
        preferVisitShort: 'Corta',
        titleVisitType: 'Visitas guiadas',
        titleMenu: 'Menú',
        moreInfo:'¿Saber más?',
        moreInfoNo: 'No',
        moreInfoYes:'Sí',
        downloadAudio: '(descargar audios)',
        download: 'Descarga de los archivos de audio',
        errorDownload: 'Ha habido un error en al descarga.',
        cancelDownload: 'Has cancelado la descarga.',
        retry: 'Reintentar',
        noConnection: 'No tienes conexión a internet',
        titleMap: '',
        map: '',

      initDownload: 'Por favor, espere mientras se descargan los audios',
      endDownload: 'Audios descargados. ¡Disfrute de la visita!',

        menuItems: [
            {
                img: '1.png',
                title: 'Bienvenida',
                map: '',
                author: '',
                imageMenu: 'barra_1.png',
                imagesAudio: [{
                                img: '1.jpg',
                                second: '0'
                            }],
                audio: '1.mp3',
                menuSubItems: []
                
            },
            {
                img: '2.png',
                title: 'El descalabro',
                map: '',
                author: '',
                imageMenu: 'barra_2.png',
                imagesAudio: [{
                                img: '2.jpg',
                                second: '0'
                            }],
                audio: '2.mp3',
                menuSubItems: []
            },
            {
                img: '3.png',
                title: 'La recuperación',
                map: '',
                author: '',
                imageMenu: 'barra_3.png',
                imagesAudio: [{
                                img: '3.jpg',
                                second: '0'
                            }],
                audio: '3.mp3',
                menuSubItems: []
                    
            },
            {
                img: '4.png',
                title: 'La bodega',
                map: '',
                author: '',
                imageMenu: 'barra_4.png',
                imagesAudio: [{
                                img: '4.jpg',
                                second: '0'
                            }],
                audio: '4.mp3',
                menuSubItems: []
            },

            {
                img: '5.png',
                title:'Los prolegómenos',
                map:'',
                author: '',
                imageMenu: 'barra_5.png',
                imagesAudio: [{
                                img: '5.jpg',
                                second: '0'
                            }],
                audio: '5.mp3',
                menuSubItems: []
                
            }
            ,
            {
                img: '6.png',
                title: 'El arquitecto',
                map: '',
                author: '',
                imageMenu: 'barra_6.png',
                imagesAudio: [{
                                img: '6.jpg',
                                second: '0'
                            }],
                audio: '6.mp3',
                menuSubItems: []
                
            },
            {
                img: '7.png',
                title: 'Abajo y arriba',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_7.png',
                imagesAudio: [{
                                img: '7.jpg',
                                second: '0'
                            }],
                audio: '7.mp3',
                menuSubItems: []
            },  
            {
                img: '8.png',
                title: 'Hasta la última gota',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_8.png',
                imagesAudio: [{
                                img: '8.jpg',
                                second: '0'
                            }],
                audio: '8.mp3',
                menuSubItems: []
            },
            {
                img: '9.png',
                title: 'El tesoro escondido',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_9.png',
                imagesAudio: [{
                                img: '9.jpg',
                                second: '0'
                            }],
                audio: '9.mp3',
                menuSubItems: []
            },
            {
                img: '10.png',
                title: 'El álbum de fotos',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_10.png',
                imagesAudio: [{
                                img: '10.jpg',
                                second: '0'
                            }],
                audio: '10.mp3',
                menuSubItems: []
            },
            {
                img: '11.png',
                title: 'Vino a raudales',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_11.png',
                imagesAudio: [{
                                img: '11.jpg',
                                second: '0'
                            }],
                audio: '11.mp3',
                menuSubItems: []
            },
            {
                img: '12.png',
                title: 'El arte del ladrillo',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_12.png',
                imagesAudio: [{
                                img: '12.jpg',
                                second: '0'
                            }],
                audio: '12.mp3',
                menuSubItems: []
            },
            {
                img: '13.png',
                title: 'Despedida',
                map: 'superior.png',
                author: '',
                imageMenu: 'barra_13.png',
                imagesAudio: [{
                                img: '13.jpg',
                                second: '0'
                            }],
                audio: '13.mp3',
                menuSubItems: []
            },
                    
            {
                img: '14.jpg',
                imageMenu: 'barra_14.png',
                title: 'Créditos ',
                author: '',
                description: 'Guió, producció, disseny i programació: Trama Media.<br><br>Fotografies cedides pel Celler de Vila-seca.<br><br>© Celler de Vila-seca.<br><br>Tots els drets reservats.<br><br>',
                audio: '',
                visitType: '{all}',
                moreInfoItem: '',
                isCredits: true,
                menuSubItems: []
         
                   
            },
        ],
    },
}



// WEBPACK FOOTER //
// ./src/data/i18n/castellano.js